/**
 * The DocumentBar class specializes the BorderBar class to display documents
 */
define([
    "dojo/_base/declare",
    "dojo/dom-attr",
    "dojo/dom-class",
    "dojo/dom-geometry",
    "MW/layout/BorderBar",
    "MW/layout/LayoutChildProperty",
    "MW/layout/LayoutContainerEvent",
    "dojo/i18n!l10n/nls/layout"
], function (declare, domAttr, domClass, domGeometry, BorderBar, LayoutChildProperty, LayoutContainerEvent, layoutL10n) {

    return declare([BorderBar], {

        postMixInProperties: function () {
            this.fixParallelDimension = false;
            this.inherited(arguments);
            this.setFacet = "_documentBarSet";
            this.displayToolTipsWhenTruncated = true;
            this.expandButtonIdPrefix = "documentBar";
        },

        buildRendering: function () {
            this.inherited(arguments);
            domClass.add(this.domNode, "documentBar");
            if (this.buttonOrientation === "horizontal") {
                domClass.add(this.domNode, "horizontalButtons");
            }
            var that = this;

            var expandButton = this.getPostNeighbor();
            domAttr.set(expandButton, "title", layoutL10n.expandDocuments);

            // Take out a loan for each document
            this.documentContainer.getDocuments().forEach(function (document) {
                var properties = that.documentContainer.getProperties(document);
                var parent     = document.getParent();
                that._setDocumentBarSetProperty(parent, properties);
                that.acceptLoan(parent, properties);
                properties.set(LayoutChildProperty.IS_SHOWING, false);
            });

            // Respond to document add and remove
            this.own(this.documentContainer.on(LayoutContainerEvent.CHILD_ADDED, function (document, properties) {
                var parent = document.getParent();
                that._setDocumentBarSetProperty(parent, properties);
                that.acceptLoan(parent, properties);
            }));
            this.own(this.documentContainer.on(LayoutContainerEvent.CHILD_REMOVED, function (document, properties) {
                that.cancelLoan(properties);
            }));
        },

        _setDocumentBarSetProperty: function (parent, properties) {
            // Group bar entries by tab container and document group
            properties._documentBarSet = parent.id + properties.setId;
        },

        destroy: function() {
            this.inherited(arguments);
            this.documentContainer.refreshShowingDocuments();
        },

        _measureButton: function (buttonInfo) {
            // Counter the rotated text assumption built into BorderBar
            var box = this.inherited(arguments);
            if (this.orientation === "vertical" && this.buttonOrientation === "horizontal") {
                var temp = box.w;
                box.w = box.h;
                box.h = temp;
            }
            return box;
        },

        _showChild: function (childInfo) {
            this.inherited(arguments);
            domClass.add(childInfo.onTopPane.domNode, "documentPane");
        },

        _isTruncated: function (buttonInfo) {
            return this.inherited(arguments) || (this.orientation === "vertical" &&
                this.buttonOrientation === "horizontal" && buttonInfo.currentBox.w < buttonInfo.preferredSize.w);
        },

        _getExpandAllItemText: function() {
            return layoutL10n.expandDocuments;
        }
    });
});
